module.exports = __webpack_public_path__ + "img/切割.2c896763.svg";